const descriptions = [
    
        { title: 'car' },
        { title: 'food' },
        { title: 'house' },
        { title: 'taxi' },
        { title: 'hotel' },
        { title: 'restaurant' },
        { title: 'airplane' },
        { title: 'bus' },
        { title: 'bike' },
        { title: 'boat' },
        { title: 'office' },
        { title: 'computer' },
        { title: 'phone' },
        { title: 'book' },
        { title: 'pen' },
        { title: 'pencil' },
        { title: 'paper' },
        { title: 'travel' },
        { title: 'work' },
        { title: 'home' },
        { title: 'electricity' },
        { title: 'hire' },
        { title: 'uber' },
        { title: 'lyft' },
        { title: 'airbnb' },
        { title: 'booking' },
        { title: 'expedia' },
        { title: 'kayak' },
        { title: 'medicine' },
        { title: 'grocery' },
        { title: 'clothes' },
        { title: 'furniture' },
        { title: 'electronics' },
        { title: 'appliances' },
        { title: 'gas' },
        { title: 'water' },
        { title: 'phone' },
        { title: 'internet' },
        { title: 'insurance' },
        { title: 'bank' },
        { title: 'credit' },
        { title: 'loan' },
        { title: 'accountant' },
        { title: 'lawyer' },
        { title: 'consultant' },
        { title: 'contractor' },
        { title: 'plumber' },
        { title: 'electrician' },
        { title: 'carpenter' },
        { title: 'dine-in' },
        { title: 'executive-meeting' },
        { title: 'conference' },
        { title: 'workshop' },
        { title: 'presentation' },
        { title: 'webinar' },
        { title: 'online-meeting' },
        { title: 'video-conference' },
        { title: 'marketing' },
        { title: 'advertising' },
        { title: 'sales' },
        { title: 'entertainment' },
        { title: 'cinemas' },
        { title: 'trip' }
      
]
const suggestions = descriptions.map((name, index) => ({ value: index, label: name }))

export { descriptions, suggestions }